import { CardType } from 'types/deck'

import styles from './oTags.module.scss'
import { SET_ACTIVE_STATE } from 'redux/active/actions/types'
import { useActionless } from 'redux/hooks'
import { generateTabState } from 'types/searchV2'
import Icon from 'components/elements/Icon'

type Props = {
  card: CardType
  onTagClicked?: () => void
}

const OTags = ({ card, onTagClicked }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <h3>Oracle tags</h3>

        <div className={styles.tags}>
          {card.oTags.map((tag, index) => (
            <OTag tagName={tag} onTagClicked={onTagClicked} key={index} />
          ))}
        </div>
      </div>

      <div>
        <h3>Inherited tags</h3>

        <div className={styles.tags}>
          {card.inheritedTags.map((tag, index) => (
            <OTag tagName={tag} onTagClicked={onTagClicked} key={index} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default OTags

type OTagProps = {
  tagName: string
  onTagClicked?: () => void
}

const OTag = ({ tagName, onTagClicked }: OTagProps) => {
  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  const handleTagClick = () => {
    const tagSlug = tagName.replace(/ /g, '-')
    const newTab = generateTabState.scrySearch()

    // @ts-ignore
    newTab.meta.query = `otag:${tagSlug}`

    if (onTagClicked) onTagClicked()

    setActiveState({ searchOpen: newTab })
  }

  return (
    <button onClick={handleTagClick} className={styles.tag}>
      <Icon name="tag" /> {tagName}
    </button>
  )
}
